import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import {TopButtonAdd} from "../../../componentsTopsa/buttons/TopButtons";
import TopIf from "../../../componentsTopsa/if/TopIf";
import SzablonForm from "./components/SzablonForm";
import SzablonyList from "./components/SzablonyList";
import SzablonyService from "./SzablonyService";

export default class SzablonyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pokazPopup: false,
            pokazFormularz: false,
            szablon: null,
            data: []
        };
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.onClickEdytuj = this.onClickEdytuj.bind(this)
    }

    componentDidMount() {
        this.pobierzSzablony()
    }

    pobierzSzablony() {
        SzablonyService.getSzablony().then(function (response) {
            this.setState({data: response.data})
        }.bind(this))
    }

    onClickZapisz(obj) {
        SzablonyService.addSzablon(obj).then(function (response) {
            this.pobierzSzablony()
            this.setState({pokazFormularz: false})
        }.bind(this))
    }

    onClickEdytuj(obj) {
        SzablonyService.putSzablon(obj).then(function (response) {
            this.pobierzSzablony()
            this.setState({pokazFormularz: false})
        }.bind(this))
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path}
                              history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'SzablonyContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/administracja', text: 'Administracja'}, {
                                    addressUrl: '/administracja/szablony',
                                    text: 'Szablony'
                                }]}/>
                                <SubHeader currentLink={this.props.match.path}
                                           obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <TopIf isTrue={!this.state.pokazFormularz}>
                                <div className={'pull-right'}>
                                    <TopButtonAdd onClick={() => {
                                        this.setState({pokazFormularz: true})
                                    }} text={'Dodaj szablon'}/>
                                </div>
                            </TopIf>
                        </Col>
                        <Col sm={12}>
                            <TopIf isTrue={this.state.pokazFormularz}>
                                <SzablonForm handleClickAnuluj={() => {
                                    this.setState({pokazFormularz: false})
                                }} onClickDodaj={this.onClickZapisz} onClickEdytuj={this.onClickEdytuj} szablon={this.state.szablon}
                                />
                            </TopIf>
                        </Col>
                        <Col xs={12}>
                            <SzablonyList data={this.state.data} handleOdswiez={()=>this.pobierzSzablony()}/>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/administracja/szablony/SzablonyContainer.js